export default {
  title_one: 'Zustellstatistiken werden für „{{title}}“ aktualisiert',
  title_other: 'Zustellstatistiken werden für {{count}} Kampagnen aktualisiert',
  subtitle_pending:
    'Apple und Google bestätigen den Empfang in ungefähr {{minutes}}m {{seconds}}s (gegen {{time}}). Die Statistiken werden automatisch aktualisiert.',
  subtitle_ready:
    'Die Bestätigungen sollten eingetroffen sein. Aktualisieren Sie die Seite, um die neuesten Zustellzahlen zu sehen.',
};
